import Api from '@/services/Api';

export default {
    fetchPromotions(params){
        return Api().get(`/4.0/promotions` , { params });
    },
}
